import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store/store";
import "@/registerServiceWorker";
import vuetify from "@/plugins/vuetify";
// import VueI18n from "vue-i18n";
import i18n from "@/utils/translations";

// Necessary for iOS, which supports Intl only after iOS 14, and some old Androids...
import "@formatjs/intl-locale/polyfill";
// Necessary for some old Androids (8.1.0)
import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/locale-data/en"; // locale-data for en

// Necessary for iOS, which supports Intl only after iOS 14, and some old Androids...
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en"; // locale-data for en

import pluralize from "pluralize";

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new VueIntegration({ Vue, attachProps: true, logErrors: true }),
  ],
});

Vue.config.productionTip = false;

const moment = require("moment");
require("moment/min/locales.min");
Vue.use(require("vue-moment"), {
  moment,
});

// TODO: move to filters file
Vue.filter("pluralize", function(value, number) {
  return pluralize(value, number);
});

var app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
});
// TODO: init app in a blank loading screen (waiting for init call)
app.$mount("#app");

// alert('app initialized n')

window.init = function(accessToken, opts) {
  //   alert(accessToken + " - " + JSON.stringify(opts));
  store.commit("setUserBoatId", { userBoatId: opts.userBoatId });
  store.commit("setAccessToken", { token: accessToken });
  store.commit("setTheme", { theme: opts.theme });
  store.commit("setLocale", { locale: opts.locale });
  store.dispatch("fetchUserBoat");
};

if (process.env.NODE_ENV === "development") {
  window.init("", {
    // userBoatId: 832,
    locale: "en",
    // theme: 'seanapps',
    // userBoatId: 17326,
    userBoatId: 1182,
    // userBoatId: 830,
    //     userBoatId: 832,
    //     theme: "seanapps",
    //     locale: "fr",

    // userBoatId: 14312
    // userBoatId: 5189
    // userBoatId: 5189
    // userBoatId: 8137,
    // userBoatId: 10372,
    // userBoatId: 10985, // zap regledati duplicate vaccum valve for engine
    // userBoatId: 12262,
    // userBoatId: 9340,
  });
}
